<template>
    <div :class="['a-modal', { fixed: fixed }]">
        <div class="background" @click="$emit('close')"></div>
        <AonContainer>
            <AonRow>
                <AonCol
                    :class="[`aon-col-${colWidth}`, `offset-${colWidthOffsetCalc}`]"
                    :remove-padding="['t', 'l', 'b', 'r']"
                    style="height: 100vh"
                >    
                    <div class="container elevation-5 pa-8">
                        <div class="a-modal-close" @click="$emit('close')">
                            <font-awesome-icon icon="far fa-xmark" class="icon dungeon-depths--text" />
                        </div>
                        <h5 v-if="title" class="dungeon-depths--text mb-5">
                            <slot name="titleIcon"></slot>
                            {{ title }}
                        </h5>
                        <p v-if="message" class="dungeon-depths--text mb-5">{{ message }}</p>
                        <slot></slot>
                    </div>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import AonContainer from './grid/AonContainer.vue';
import AonRow from './grid/AonRow.vue';
import AonCol from './grid/AonCol.vue';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    message: {
        type: String,
        default: '',
    },
    fixed: {
        type: Boolean,
        default: true,
    },
    colWidth: {
        type: String,
        default: '6',
        validator: (val) => {
            return ['4', '6', '8', '10'].includes(val)
        },
        colWidth: {
            type: String,
            default: '6',
            validator: (val) => ['4', '6', '8', '10'].includes(val),
        },
    },
})

const colWidthOffsetCalc = computed(() => {
    if (props.colWidth === '4') {
        return '4'
    } else if (props.colWidth === '6') {
        return '3'
    } else if (props.colWidth === '8') {
        return '2'
    } else {
        return '1'
    }
})

</script>

<script>
    export default {
        name: 'AonModal'
    }
</script>

<style lang="scss">
.a-modal {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.fixed {
        position: fixed;
        z-index: 1;
    }

    .background {
        background: $grey01;
        opacity: 0.8;
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }

    .container {
        background: white;
        border-radius: $border-radius;
        width: 100%;
        height: fit-content;
        max-height: 650px;
        overflow: auto;

        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .a-modal-close {
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: pointer;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
